import React, { useState, useEffect, useRef } from 'react';
import { View, Text, Pressable, Platform } from 'react-native';
import styles from '../../styles/pages/projectstatusStyles';

interface TimelineBarProps {
  period: {
    startDate: string | null;
    endDate: string | null;
  };
  label: string;
  style: any;
  formatDate: (date: string) => string;
  progress?: number;
  currentProgress?: number;
}

export default function TimelineBar({
  period,
  label,
  style,
  formatDate,
  progress,
  currentProgress,
}: TimelineBarProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  if (
    !period.startDate ||
    !period.endDate ||
    period.startDate === '' ||
    period.endDate === ''
  ) {
    return null;
  }

  // style에서 position 관련 속성 추출
  const { left, right, top, position, ...restStyle } = style[1] || {};
  const containerStyle = {
    position: position || 'absolute',
    left,
    right,
    top,
  };

  return (
    <View style={[containerStyle as any, { overflow: 'visible', zIndex: showTooltip ? 1000 : 1 }]}>
      <Pressable
        style={[style[0], restStyle, { position: 'relative' }]}
        onHoverIn={() => setShowTooltip(true)}
        onHoverOut={() => setShowTooltip(false)}
      >
        <Text style={styles.timelineLabel}>{label}</Text>
        {progress !== undefined && (
          <View
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
              width: `${progress}%`,
              backgroundColor: 'rgba(46, 125, 50, 0.5)',
              borderRadius: 4,
            }}
          />
        )}
        {showTooltip && (
          <View
            style={[
              {
                position: 'absolute',
                left: '50%',
                bottom: '100%',
                transform: [{ translateX: '-50%' }],
                marginBottom: 5,
                zIndex: 10000,
                pointerEvents: 'none',
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                padding: 10,
                borderRadius: 6,
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.3,
                shadowRadius: 4,
                elevation: 10,
                minWidth: 200,
              },
            ]}
          >
            <Text 
              style={[
                { 
                  color: '#fff', 
                  fontSize: 13, 
                  fontWeight: '500', 
                  textAlign: 'center',
                },
                Platform.OS === 'web' ? { whiteSpace: 'nowrap' } as any : {}
              ]}
              numberOfLines={1}
            >
              {`${label}: ${formatDate(period.startDate)} ~ ${formatDate(period.endDate)}`}
            </Text>
          </View>
        )}
      </Pressable>
    </View>
  );
}
